import * as React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Availability, ProfessionalData, GeneralSettingsData } from '../../../../models';
import AppButton from '../../../../components/AppButton';
import { useTranslations } from '../../../../store/translations/hooks';
import { TK } from '../../../../store/translations/translationKeys';

interface ConfirmSlotBarProps {
    slot: Availability;
    professionals: ProfessionalData[];
    selectedService: string | undefined;
    settings: GeneralSettingsData;
    onConfirm: () => void;
}

const Bar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacer-S);
    padding: var(--spacer-S) var(--spacer-M);
    background: var(--success-bg);
    border: var(--border-thin) solid var(--success-border);
    border-radius: 4px;
    margin-top: var(--spacer-M);
`;

const Details = styled.div`
    font-size: 0.9rem;
    color: var(--text-body);
`;

const ConfirmSlotBar: React.FC<ConfirmSlotBarProps> = ({
    slot,
    professionals,
    selectedService,
    settings,
    onConfirm,
}) => {
    const t = useTranslations();
    const prof = professionals.find(p => p.id === slot.professionalId);
    const serviceName = selectedService
        ? (settings.services?.[selectedService]?.name ?? selectedService)
        : undefined;

    return (
        <Bar>
            <Details>
                <strong>{moment(slot.dateTime).format('DD/MM/YYYY HH:mm')}</strong>
                {prof && <span> — {prof.name}</span>}
                {serviceName && <span> — {serviceName}</span>}
                {slot.room && <span> — {slot.room}</span>}
            </Details>
            <AppButton color="success" onClick={onConfirm}>
                {t(TK.confirmSlot)}
            </AppButton>
        </Bar>
    );
};

export default ConfirmSlotBar;
